import { render, staticRenderFns } from "./Revision.vue?vue&type=template&id=7d2108c2"
import script from "./Revision.vue?vue&type=script&lang=ts"
export * from "./Revision.vue?vue&type=script&lang=ts"
import style0 from "./Revision.vue?vue&type=style&index=0&id=7d2108c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports